export class CustomerSelectList {
  id?: number;
  fullName?: string;

  constructor(model: CustomerSelectList) {
    this.id = model.id || 0;
    this.fullName = model.fullName || '';
  }
}
